<section [id]="'sidebar-' + name" [class]="'sidebar ' + class" [ngClass]="{'dark': this.dark}" [style]="zIndex">
  <div class="sidebar-header">
    <span class="title">{{this.sidebar.title}}</span>
    <span (click)="closeSidebar()" style="color: white;" placement="left" ngbTooltip="Cerrar" class="action">
      <i [data-feather]="'x'" size="20"></i>
    </span>
  </div>
  <ng-content [select]="select"></ng-content>
</section>
<div class="backgrop"></div>